import { ToastContainer } from "react-toastify";
import Router from "router";

import { AcceptModal } from "components/AcceptModal";
import { BrowserDetectModal } from "components/BrowserDetectModal/BrowserDetectModal";
import { AddPropertyAcceptModal } from "components/OwnerPortalAcceptModal";

import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <Router />
      <AcceptModal />
      <AddPropertyAcceptModal />
      <ToastContainer
        closeOnClick
        draggable
        hideProgressBar
        pauseOnFocusLoss
        pauseOnHover
        autoClose={5000}
        newestOnTop={false}
        position="top-right"
        rtl={false}
        theme="colored"
      />
      <BrowserDetectModal />
    </>
  );
}

export default App;
